import { Tooltip } from '@material-ui/core';
import React from 'react';

const smartLabelStyles = {
  backgroundColor: '#FCD21F',
  borderRadius: 4,
  paddingLeft: 4,
  paddingRight: 4,
  paddingY: 2,
  color: '#000000',
  fontSize: 11,
  fontWeight: 700,
  display: 'flex',
  alignItems: 'center',
  gap: 4,
};

const dotStyles = {
  width: 6,
  height: 6,
  borderRadius: '50%',
  backgroundColor: '#670EAB',
};

const SmartClubLabel = () => (
  <Tooltip title="Smart Club Membership">
    <div style={smartLabelStyles}>
      <div style={dotStyles} />
      <div>SmartClub</div>
    </div>
  </Tooltip>
);

export default SmartClubLabel;
